import React, { useEffect } from "react";
import { RouteComponentProps } from "react-router";
import { WORKFORCE } from "constants/app";

type IWebcalRedirect = RouteComponentProps<{
  permalink: string;
  uuid: string;
}>;

export default function WebcalRedirect({ match }: IWebcalRedirect) {
  useEffect(() => {
    const { permalink, uuid } = match.params;
    const webcalRoot = WORKFORCE.replace(/https?/, "webcal");

    if (permalink && uuid) {
      window.location.href = `${webcalRoot}/calendars/${permalink}/${uuid}.ics`;
    }
  });

  return <em>Redirecting to your calendar webcal feed...</em>;
}
